import { Directive, OnDestroy, OnInit } from '@angular/core';
import { lockBodyScroll, unlockBodyScroll } from '../../../common/components/modal/body-scroll-lock';

/**
 * Native port of the AngularJS `ftEnsureModalSingleScroll` attribute directive
 * (account-v1/.../directives/ensure-modal-single-scroll/ensureModalSingleScroll.ts). While the
 * host lives, `<body>` is locked to `overflow:hidden` so only the modal scrolls — the AngularJS
 * version toggled a `.ensure-modal-single-scroll { overflow:hidden }` body class, but that CSS
 * lived in the now-dead account-v2 assets and is not bundled, so the lock is applied inline here.
 * Released on destroy (the launcher tears the modal instance down on close). The lock is the
 * shared ref-counted one from body-scroll-lock.ts: an ft-modal-overlay stacked on top of this
 * host (story modal → broadcast, contest container → field-editor sheet) must not clear the
 * body lock when it closes first.
 */
@Directive({ selector: '[ft-ensure-modal-single-scroll]' })
export class FtEnsureModalSingleScrollDirective implements OnInit, OnDestroy {
    ngOnInit(): void {
        lockBodyScroll();
    }

    ngOnDestroy(): void {
        unlockBodyScroll();
    }
}
